import { authHeader } from "../../_helpers/auth-header";
import { appConfig, headerConfig } from "../../config";
import auth from "../auth";

export const userService = {
  login,
  logout,
  userList,
  userStatus,
  createUser,
  userDelete
};

function refineHeader() {
  let token = auth.getToken();
  if (token != "") {
    headerConfig.headerDatas["Authorization"] = "Bearer " + token;
  }
}

function login(email, password, login_as) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify({ email, password, login_as })
  };

  return fetch(`${appConfig.api.url}login`, requestOptions)
    .then(handleResponse)
    .then(user => {
      // login successful if there's a jwt token in the response
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("user", JSON.stringify(user.result.token));

      auth.setToken(user.result.token);
      const {
        status,
        firstName,
        lastName,
        userName,
        userTypeName
      } = user.result;
      const userdata = {
        status,
        firstName,
        lastName,
        userName,
        userTypeName
      };
      auth.setUserInfo(userdata);
      return user;
    });
}

function logout() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}logout`, requestOptions)
    .then(handleResponse)
    .then(user => {
      auth.clearAllAppStorage();
      localStorage.removeItem("user");
      return user;
    });
}

function userList(formData, url){
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
  });
}

function userStatus(formData, url){
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
  });
}

function createUser(formData, url, type){
  refineHeader();
  const requestOptions = {
    method: type,
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
  });
}

function userDelete(url){
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
  });
}

function userDelete(url){
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
  });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/userService.js